import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { getDateInTimezone } from '../utils/date-time';
export const useDateStore = (storage) => create()(persist((set) => ({
    selectedDate: getDateInTimezone(),
    setSelectedDate: (date) => set({ selectedDate: date }),
}), {
    name: 'dateStore',
    storage: createJSONStorage(() => storage || sessionStorage),
}));
